import React from 'react';
import { GlobalContext } from '../GlobalContext';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../assets/styles/header.css';

function Header() {
  const global = React.useContext(GlobalContext);
  const location = useLocation();

  React.useEffect(() => {
    if (localStorage.hasOwnProperty('isToten')) {
      const toten = JSON.parse(localStorage.getItem('isToten'));
      if (toten) global.setIsToten(true);
    }
  }, []);

  const headerClass = `main_header 
  ${global.isToten ? 'toten' : ''} 
  ${location.pathname.includes('/orderqueue') ||
      location.pathname.includes('/create-customer')
      ? 'orderqueue'
      : ''
    }`.trim();

  return (
    <header className={headerClass}>
      <nav>
        <div className="bar-header-container">
          <Link to={localStorage.getItem('tableNumber') ? `/${localStorage.getItem('tableNumber')}` : "/"}>
            <img src={global.image} alt="logo" />
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
